import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function RoleSelectionPage() {
    const navigate = useNavigate();

    const handleRoleSelect = (role: "teacher" | "non_educator") => {
        navigate(`/register?role=${role}`);
    };

    return (
        <main
            className="min-h-screen flex flex-col items-center justify-center px-4 py-8 bg-brand-radial"
            role="main"
            aria-labelledby="welcome-heading"
        >
            <div className="w-full max-w-md space-y-8 text-center">
                {/* Logo/Brand */}
                <div className="space-y-2">
                    <h1
                        id="welcome-heading"
                        className="text-4xl md:text-5xl font-bold text-white tracking-tight font-heading"
                    >
                        Hall Pass
                    </h1>
                    <p className="text-lg text-muted-foreground">
                        Connect with your perfect match
                    </p>
                </div>

                {/* Role Selection */}
                <div className="space-y-4 pt-8">
                    <h2 className="text-xl font-semibold text-foreground">
                        I am a...
                    </h2>

                    <div
                        className="flex flex-col gap-4 sm:flex-row sm:gap-6 justify-center"
                        role="group"
                        aria-label="Select your role"
                    >
                        <Button
                            onClick={() => handleRoleSelect("teacher")}
                            size="lg"
                            className="w-full sm:w-48 h-14 text-lg bg-brand-primary text-brand-background hover:bg-brand-primary/90 font-semibold shadow-brand-glow hover:shadow-lg hover:scale-105 transition-all duration-200"
                            aria-describedby="teacher-desc"
                        >
                            Teacher
                        </Button>
                        <span id="teacher-desc" className="sr-only">
                            Select if you are a teacher looking to connect
                        </span>

                        <Button
                            onClick={() => handleRoleSelect("non_educator")}
                            size="lg"
                            variant="outline"
                            className="w-full sm:w-48 h-14 text-lg border-2 border-brand-primary text-brand-primary hover:bg-brand-primary/10 font-semibold shadow-brand-glow hover:shadow-lg hover:scale-105 transition-all duration-200"
                            aria-describedby="non-educator-desc"
                        >
                            Non-Educator
                        </Button>
                        <span id="non-educator-desc" className="sr-only">
                            Select if you are a non-educator looking to connect
                        </span>
                    </div>
                </div>

                {/* Footer note */}
                <p className="text-sm text-muted-foreground pt-8">
                    By continuing, you agree to our Terms of Service and Privacy Policy
                </p>
            </div>
        </main>
    );
}
